import React, { lazy, Suspense, useEffect, useState } from 'react';
import { MotionConfig } from 'framer-motion';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { HookSection } from './components/HookSection';
import { AgitationSection } from './components/AgitationSection';
import { RevelationSection } from './components/RevelationSection';
import { Testimonials } from './components/Testimonials';
import { OfferSection } from './components/OfferSection';
import { FlameIcon } from './components/icons/Icons';
const FaqSection = lazy(() => import('./components/FaqSection').then(module => ({
  default: module.FaqSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(module => ({
  default: module.GuaranteeSection
})));
const ClosingSection = lazy(() => import('./components/ClosingSection').then(module => ({
  default: module.ClosingSection
})));
const PurchaseNotifications = lazy(() => import('./components/PurchaseNotifications').then(module => ({
  default: module.PurchaseNotifications
})));
type IdleWindow = Window & {
  requestIdleCallback?: (callback: () => void, options?: {
    timeout: number;
  }) => number;
  cancelIdleCallback?: (id: number) => void;
};
export function App() {
  const [loadNotifications, setLoadNotifications] = useState(false);
  const [loadDeferredSections, setLoadDeferredSections] = useState(false);
  useEffect(() => {
    const idleWindow = window as IdleWindow;
    const loadSections = () => setLoadDeferredSections(true);
    const idleId = idleWindow.requestIdleCallback?.(loadSections, {
      timeout: 1200
    });
    const sectionTimer = idleId !== undefined ? undefined : window.setTimeout(loadSections, 300);
    const notificationTimer = window.setTimeout(() => setLoadNotifications(true), 1000);
    return () => {
      if (idleId !== undefined) idleWindow.cancelIdleCallback?.(idleId);
      if (sectionTimer !== undefined) window.clearTimeout(sectionTimer);
      window.clearTimeout(notificationTimer);
    };
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3uc9j1w993mja">
      <div className="w-full bg-[#f7f4ec]" data-id="element-1" data-mp="d4nv7fl6zi1v">
        <UrgencyBar data-id="element-2" data-mp="d3cuxpqygsfi" />
      <main className="w-full" data-id="element-3" data-mp="d3wcv6glvgtj">
        <Hero data-id="element-4" data-mp="85l1granwy97" />
        <HookSection data-id="element-5" data-mp="851lvh8hilyc" />
        <AgitationSection data-id="element-6" data-mp="86mc4unrniqe" />
        <RevelationSection data-id="element-7" data-mp="86ckz3qzj5j4" />
        <Testimonials data-id="element-8" data-mp="3gle9siuub3f6" />
        <OfferSection data-id="element-9" data-mp="3gklag2y7ng72" />
        {loadDeferredSections && <Suspense fallback={null} data-id="element-10" data-mp="3gj1r23h9cp12">
            <FaqSection data-id="element-11" data-mp="3bn2ye3owckuu" />
            <GuaranteeSection data-id="element-12" data-mp="3bnuurgqbimm6" />
            <ClosingSection data-id="element-13" data-mp="3bkgq21u6m1bk" />
          </Suspense>}
      </main>

      <footer className="w-full bg-[#161e18] py-10 text-center text-white/60" data-id="element-14" data-mp="3qcqzb3t61hi1">
        <div className="mx-auto max-w-3xl px-5" data-id="element-15" data-mp="3ljg0npyic717">
          <div className="flex items-center justify-center gap-2 text-[#7fbf74]" data-id="element-16" data-mp="3limv2sbabnkn">
            <FlameIcon className="h-5 w-5" strokeWidth={2.2} data-id="element-17" data-mp="2xssh27f8bsyt" />
            <span className="font-display text-base font-bold text-white" data-id="element-18" data-mp="2sur0bt5a05qi">
              Método GastroSmart
            </span>
          </div>
          <p className="mx-auto mt-4 max-w-xl text-xs leading-relaxed" data-id="element-19" data-mp="18bomcry0clzl">
            Este contenido tiene fines educativos y no sustituye el consejo
            médico profesional. Consulta a tu médico antes de iniciar cualquier
            protocolo. Resultados individuales pueden variar.
          </p>
          <p className="mt-4 text-xs" data-id="element-20" data-mp="13cbvlw40murq">
            © 2026 GastroSmart. Todos los derechos reservados.
          </p>
        </div>
      </footer>

        {loadNotifications && <Suspense fallback={null} data-id="element-21" data-mp="1w2khnz1o9zbl">
            <PurchaseNotifications data-id="element-22" data-mp="1i3uk6iaxxxmp" />
          </Suspense>}
      </div>
    </MotionConfig>;
}